module.exports = __webpack_public_path__ + "static/media/landing-woman.4813318e.png";